import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

/*
card is a lightweight version of 'panel'
card header, title and footer are optional fields and won't render if empty / missing

card src: adds an image at the top of the card
NOTE: the width of the card will match the image width
card alt: description of the image

card header: section at the top of the card
card title: header inside card body; if missing then only the card body will render
card body: main content
card footer: section at the bottom of the card

customClass: Allows a custom class styling for the card component, if provided as a prop
customHeader: Allows custom class styling for the header, if provided as a prop
*/

const Card = props => {
  const {
    children, customClass, customBodyClass, customHeader, header, footer, title,
    alt, src, id,
  } = props;
  return (
    <div className={`card ${customClass}`}>
      {!isEmpty(src) ? <img className="card-img-top" src={src} alt={alt} /> : null}
      {!isEmpty(header) ? <div className={`card-header ${customHeader}`} id={id}>{header}</div> : null}
      {!isEmpty(title)
        ? (
          <div className="card-body">
            <h5 className="card-title">
              {title}
            </h5>
            <div className="card-text">{children}</div>
          </div>
        )
        : (
          <div className={`card-body ${customBodyClass}`}>
            <div className="card-text">{children}</div>
          </div>
        )}
      {!isEmpty(footer) && footer !== null
        ? <div className="card-footer">{footer}</div> : null}
    </div>
  );
};

Card.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.node,
  customClass: PropTypes.string,
  customBodyClass: PropTypes.string,
  customHeader: PropTypes.string,
  header: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(),
  ]),
  footer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  src: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.string,
};

Card.defaultProps = {
  alt: null,
  customClass: '',
  customHeader: '',
  customBodyClass: '',
  header: null,
  footer: null,
  src: null,
  title: null,
  id: null,
};

export default Card;
